import { Request, RequestTicket, RequestTicketReceipt } from 'src/types'
import { useGetAdvances, useGetExpenses } from 'src/components/atoms'

function totalServicesSum(acc: number, cur: RequestTicket) {
  if (['AIR', 'HOTEL', 'VEHICLE'].includes(cur.request_ticket_type)) {
    return acc + cur.cost
  }
  return acc
}

function refundableTicketFilter(acc: RequestTicket[], cur: RequestTicket) {
  if (+cur.tenant_id === 559042084949 && cur.is_toodopay) {
    return [...acc, { ...cur }]
  }
  const refundableReceiptsFilter = cur.request_ticket_receipts.filter(
    ({ payment_resource }: RequestTicketReceipt) => payment_resource.refundable
  )

  if (!refundableReceiptsFilter.length) {
    return acc
  }
  return [
    ...acc,
    { ...cur, request_ticket_receipts: { ...refundableReceiptsFilter } }
  ]
}

function sumOfAdvances(
  acc: number,
  { request_ticket_id, request_ticket_title_advances }: RequestTicket
) {
  return request_ticket_id
    ? acc + request_ticket_title_advances[0].cost
    : acc +
        request_ticket_title_advances[0].amount *
          request_ticket_title_advances[0].exchange_rate
}

function sumOfExpenses(
  acc: number,
  { request_ticket_receipts, status }: RequestTicket
) {
  return ['EMISSION_CANCELED'].includes(status)
    ? acc
    : acc + request_ticket_receipts[0].cost
}

function useRequestTotals(request: Request) {
  const advancesFound = useGetAdvances(request)
  const expensesFound = useGetExpenses(request) // default value type ['EXPENSE']
  const totalSumAdvances = advancesFound.reduce(sumOfAdvances, 0)
  const totalSumExpensesRefundable = expensesFound
    .reduce(refundableTicketFilter, [])
    .reduce(sumOfExpenses, 0)

  const expenses = request.cost

  const total = totalSumAdvances - totalSumExpensesRefundable

  const totalServices = request.request_tickets.reduce(totalServicesSum, 0)
  const totalExpenses = expensesFound.reduce(sumOfExpenses, 0)
  return {
    advances: totalSumAdvances,
    expenses,
    total,
    totalServices,
    totalExpenses
  }
}

export default useRequestTotals
